import { defineComponent as _defineComponent } from 'vue'
import { reactive, watch, ref } from "vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  const ANY_VALUE = "Any";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseDesignFilter',
  props: {
    houses: {}
  },
  emits: ["update:filteredHouses"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(990);
  const showFilters = ref(false);
  const props = __props;
  const emit = __emit;

  const toggleFilters = () => {
    showFilters.value = !showFilters.value;
  };

  const filters = reactive([
    {
      type: "bedroom",
      label: "Bedrooms",
      options: [ANY_VALUE, 1, 2, 3, 4],
      selection: ANY_VALUE,
    },
    {
      type: "bathroom",
      label: "Bathrooms",
      options: [ANY_VALUE, 1, 2, 3, 4],
      selection: ANY_VALUE,
    },
    {
      type: "storey",
      label: "Storeys",
      options: [ANY_VALUE, 1, 2, 3],
      selection: ANY_VALUE,
    },
  ]);

  const onSelect = (type: string, value: string) => {
    const filter = filters.find((f) => f.type === type);

    if (filter) filter.selection = value;

    filterHouses();
  };
  const matchesSelection = (selection: string, value: number) =>
    selection === ANY_VALUE || Number(selection) === value;

  const filterHouses = () => {
    const filtered = props.houses.filter((house) => {
      return (
        matchesSelection(filters[0].selection, house.bedroom) &&
        matchesSelection(filters[1].selection, house.bathroom.quantity) &&
        matchesSelection(filters[2].selection, house.storey)
      );
    });

    emit("update:filteredHouses", filtered);
  };

  watch(() => props.houses, filterHouses);

const __returned__ = { isDesktop, showFilters, props, emit, toggleFilters, ANY_VALUE, filters, onSelect, matchesSelection, filterHouses, reactive, watch, ref, get HouseDesignInterface() { return HouseDesignInterface }, DropDown, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})